(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusAssessControllers', [
            'recomModule'
        ]);
})();
